<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="update-portal-user-modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <form @submit.prevent="submit">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">
                &times;
              </span>
            </button>

            <h4 class="modal-title">
              Update Portal User
            </h4>
          </div>

          <div class="modal-body">
            <SelectFormGroup
                v-model="data.portal_id"
                name="portal"
                label="Portal"
                :options="portalOptions"
                :error="(errors.portal_id || [])[0]"
            />

            <TypeaheadFormGroup
                v-model="data.user_id"
                name="user_id"
                label="User"
                endpoint="/api/v2/users"
                :token="shared.token"
                path="data.data"
                placeholder="Search..."
                :result-label-property="row => row.attributes.full_name"
            />
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>

            <button type="submit" class="btn btn-black">
              <i class="fa fa-save"></i> Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import store from '@/store'
import Errors from '@/mixins/Errors'
import SelectFormGroup from '@/vendor/forms/FormGroups/Block/Select'
import TypeaheadFormGroup from "../../../vendor/forms/FormGroups/Block/Typeahead.vue";

export default {
  components: {TypeaheadFormGroup, SelectFormGroup},

  mixins: [Errors],

  props: {
    selected: {
      type: Array
    },

    portals: {
      type: Array
    }
  },

  data() {
    return {
      data: {},

      shared: store
    }
  },

  mounted() {
    this.listenForClose()
  },

  computed: {
    portalOptions() {
      return this.portals.map(portal => {
        return {
          value: portal.id,
          label: portal.attributes.name
        }
      })
    },
  },

  methods: {
    listenForClose() {
      $(this.$el).on('hidden.bs.modal', this.reset)
    },

    submit() {
      if (!this.data.portal_id) {
        this.errors = {portal_id: ["The portal field is required"]}

        return
      }

      if (!this.data.user_id) {
        this.errors = {user_id: ["The user field is required"]}

        return
      }

      this.errors = {}

      Promise
          .all(this.selected.map(company => http.put('/api/v2/companies/' + company.id + '/portals/' + this.data.portal_id + '/user', {user_id: this.data.user_id}).catch(() => {
          })))
          .then(responses => {
            notify.success('The portal user was updated')

            responses.map(response => this.$emit('updated', response.data.data))

            $(this.$el).modal('hide')
          })
    },

    reset() {
      this.errors = {}

      this.data = {}
    }
  }
}
</script>
